export default __webpack_public_path__ + "static/12-7f9d40bd47a51a6d697b69198227e704.png";